import {colorPrimitive} from '../../styles/primitives/colorPrimitive';
import {DARK_APP_FOREGROUND_COLOR} from '../dark/darkColorHelpers';
import {LIGHT_APP_FOREGROUND_COLOR} from '../light/lightColorHelpers';
import {
  redesignedDarkBackgroundSemanticStyles,
  redesignedLightBackgroundSemanticStyles,
} from './backgroundSemanticStyles';
import {redesignedDarkBorderSemanticStyles} from './borderSemanticStyles';

export interface AppFrameSemanticStyles {
  backgroundColor: string;
  mainContentFrame: {
    borderRadius: string;
    margin: string;
    backgroundColor: string;
    border: string;
  };
  sidePanelGap: number;
}

export const lightAppFrameSemanticStyles: AppFrameSemanticStyles = {
  backgroundColor: LIGHT_APP_FOREGROUND_COLOR,
  mainContentFrame: {
    borderRadius: 'none',
    margin: '0px',
    backgroundColor: LIGHT_APP_FOREGROUND_COLOR,
    border: colorPrimitive.alpha.transparent,
  },
  sidePanelGap: 0,
} as const satisfies AppFrameSemanticStyles;

export const darkAppFrameSemanticStyles: AppFrameSemanticStyles = {
  // Most UIs assume the app frame has a white background. Because of this, we only
  // set a dark background color if an expanded dark theme is provided.
  backgroundColor: LIGHT_APP_FOREGROUND_COLOR,
  mainContentFrame: {
    borderRadius: 'none',
    margin: '0px',
    backgroundColor: DARK_APP_FOREGROUND_COLOR,
    border: colorPrimitive.alpha.transparent,
  },
  sidePanelGap: 0,
} as const satisfies AppFrameSemanticStyles;

export const expandedDarkAppFrameSemanticStyles = {
  backgroundColor: DARK_APP_FOREGROUND_COLOR,
  mainContentFrame: {
    borderRadius: 'none',
    margin: '0px',
    backgroundColor: DARK_APP_FOREGROUND_COLOR,
    border: colorPrimitive.alpha.transparent,
  },
  sidePanelGap: 0,
} as const satisfies AppFrameSemanticStyles;

export const redesignedLightAppFrameSemanticStyles = {
  backgroundColor: redesignedLightBackgroundSemanticStyles.base,
  mainContentFrame: {
    backgroundColor: redesignedLightBackgroundSemanticStyles.surface.primary,
    borderRadius: '10px',
    margin: '8px',
    border: colorPrimitive.alpha.transparent,
  },
  sidePanelGap: 8,
} as const satisfies AppFrameSemanticStyles;

export const redesignedDarkAppFrameSemanticStyles = {
  backgroundColor: redesignedDarkBackgroundSemanticStyles.base,
  mainContentFrame: {
    backgroundColor: redesignedDarkBackgroundSemanticStyles.surface.primary,
    borderRadius: '10px',
    margin: '8px',
    border: redesignedDarkBorderSemanticStyles.tertiary,
  },
  sidePanelGap: 8,
} as const satisfies AppFrameSemanticStyles;
